import { config } from './config';
import { ResolveStrategy } from './symbols';
export function resolvable(target) {
    const strategy = isClassDescriptor(target) ? config.defaultStrategy : target;
    function decorator({ elements }) {
        elements.push({
            kind: 'field',
            placement: 'own',
            key: strategy.kind,
            descriptor: {},
            initializer: function () {
                return strategy;
            }
        });
    }
    return isClassDescriptor(target) ? decorator(target) : decorator;
}
resolvable.get = (resolvable) => {
    return resolvable[ResolveStrategy] || null;
};
function isClassDescriptor(target) {
    return target?.kind === 'class' && Array.isArray(target.elements);
}
